// 跳转https地址
if (!process.env.NODE_ENV === 'development') {
	const urlArr = window.location.href.split('://');
	if (urlArr[0] === 'http') {
		urlArr[0] = 'https';
		window.location.href = urlArr.join('://');
	}
}

import Vue from 'vue';
import App from './App.vue';
// rem适配
import 'lib-flexible/flexible';
// 路由
import router from './router';
import Router from 'vue-router'
Vue.use(Router);
// vant2 https://vant-contrib.gitee.io/vant/v2/#/zh-CN/home
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
// 轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';
Vue.use(VueAwesomeSwiper);

// 微信js-sdk
import wx from 'weixin-js-sdk';
import {getCode, initJssdk} from "@/common/wxjssdk.util";
import {getUniqueCode, isWeChatOpen} from "@/common/util";
Vue.prototype.$wx= wx;
// 开放标签属于自定义标签，Vue会给予未知标签的警告，可通过配置Vue.config.ignoredElements来忽略 Vue 对开放标签的检查
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
if (isWeChatOpen()) {
	// init
	initJssdk();
}

//视频播放
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import {baseURL} from "@/common/request";
import VConsole from "vconsole";
Vue.use(VueVideoPlayer);


Vue.config.productionTip = false;

new Vue({
	router: router,
	render: h => h(App),
}).$mount('#app')


// 禁止右键菜单
document.oncontextmenu = function() {
	return false;
};
// 禁止文字选择
document.onselectstart = function() {
	return false;
};
// 禁止复制
document.oncopy = function() {
	return false;
};
// 禁止剪切
document.oncut = function() {
	return false;
};


window.onkeydown = window.onkeyup = window.onkeypress = function(event) {
	// 禁止使用F12，判断是否按下F12，F12键码为123
	if (event.keyCode === 123) {
		// 阻止默认事件
		event.preventDefault();
		window.event.returnValue = false;
	}
   // 禁用 ctrl + s 与 command + s
	if ((event.ctrlKey || event.metaKey) && event.key === 's') {
		// 阻止默认事件
		event.preventDefault()
		window.event.returnValue = false;
	}
};

// const vConsole = new VConsole()
// Vue.use(vConsole);